import { http } from '../http';
import { Params } from '@/facilities/model/user';
const BASEURL = '/api/lift/complaint';

export const creatCaseManagement = async (params: Params) => {
  return await http.post(BASEURL, params);
};

export const updateCaseManage = async (params: Params) => {
  return await http.put(`${BASEURL}/complainant`, params);
};

export const getCaseDetails = async (id?: string) => {
  return await http.get(`${BASEURL}/${id}`);
};

export const searchLocation = async (params?: Params) => {
  return await http.get('/api/building/snapshot', { params });
};

export type CaseWorkflowAction =
  | 'dispatch'
  | 'reschedule'
  | 'collected'
  | 'close'
  | 'cancel'
  | 'reopen';

export interface CaseActionParams {
  contractor?: string;
  appointmentDate?: string;
  appointmentWindow?: string;
  collectedAt?: string;
  collectedItems?: string[];
  note?: string;
  notifyResident?: boolean;
}

/** Bulky item removal workflow: OPEN -> DISPATCHED -> COLLECTED -> CLOSED (+ cancel / reopen) */
export const caseWorkflow = async (
  id: number | string,
  action: CaseWorkflowAction,
  params: CaseActionParams = {},
) => {
  return await http.post(`${BASEURL}/${id}/workflow/${action}`, params);
};

export const getCaseCount = async () => {
  return await http.get(`${BASEURL}/cnt`);
};
